<script>
	export default {
		name: 'VersionExecuter',
		methods: {
			getMajorVersion() {
				const self_ = this;
				return self_.$_verExec_getVersion(1)
			},
			getMinorVersion() {
				const self_ = this;
				return self_.$_verExec_getVersion(2)
			},
			getCommitVersion() {
				const self_ = this;
				return self_.$_verExec_getVersion(3)
			},
			getDeployedYear() {
				const self_ = this;
				return self_.$_verExec_getVersion(4)
			},
			getDeployedMonth() {
				const self_ = this;
				return self_.$_verExec_getVersion(5)
			},
			getDeployedDay() {
				const self_ = this;
				return self_.$_verExec_getVersion(6)
			},
			getDeployedDate() {
				const self_ = this;
				const year_ = self_.getDeployedYear()
				const month_ = self_.getDeployedMonth()
				const day_ = self_.getDeployedDay()
				return year_ + '/' + month_ + '/' + day_
			},
			getDeployedVersion() {
				const self_ = this;
				return self_.$_verExec_getVersion(7)
			},
			getMajorVersionLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(1)
			},
			getMinorVersionLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(2)
			},
			getCommitVersionLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(3)
			},
			getDeployedYearLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(4)
			},
			getDeployedMonthLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(5)
			},
			getDeployedDayLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(6)
			},
			getDeployedDateLocal() {
				const self_ = this;
				const year_ = self_.getDeployedYearLocal()
				const month_ = self_.getDeployedMonthLocal()
				const day_ = self_.getDeployedDayLocal()
				return year_ + '/' + month_ + '/' + day_
			},
			getDeployedVersionLocal() {
				const self_ = this;
				return self_.$_verExec_getVersionLocal(7)
			},
			$_verExec_getVersion(key) {
				const self_ = this;
				const version_ = self_.appVersion.split('.')
				return version_[key]
			},
			$_verExec_getVersionLocal(key) {
				const self_ = this;
				const version_ = self_.getLocalStorage('version').split('.')
				return version_[key]
			}
		}
	}
</script>